<template>
  <Header />

  <div class="section container">
    <div class="content">
      <div class="heading">
        <h1>Authentication Failed</h1>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';

export default {
  components: {
    Header
  }
}
</script>
